import React, { useState, useEffect } from 'react';
import { Modal, Button, Space } from 'antd';
import dayjs from 'dayjs';
import api from '../utils/api';

// Har festival ke din poore din dikhta hai: pehle bada popup, band karne ke baad
// din bhar ek patti. Photo festival ke devta ke hisaab se aati hai.
const IMAGES = {
  krishna: '/festivals/krishna.jpg',
  ganesh: '/festivals/ganesh.jpg',
  shiv: '/festivals/shiv.jpg',
  durga: '/festivals/durga.jpg',
  laxmi: '/festivals/laxmi.jpg',
  hanuman: '/festivals/hanuman.jpg',
  ram: '/festivals/ram.jpg',
  saraswati: '/festivals/saraswati.jpg',
  surya: '/festivals/surya.jpg',
  rakhi: '/festivals/rakhi.jpg',
  holi: '/festivals/holi.jpg',
  flag: '/festivals/flag.png',
  shubh: '/festivals/shubh.jpg',
};

export default function FestivalPopup() {
  const [festivals, setFestivals] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get('/festivals/today')
      .then(r => {
        const list = Array.isArray(r.data) ? r.data : [];
        setFestivals(list);
        if (list.length > 0) {
          const key = `festival-seen-${dayjs().format('YYYY-MM-DD')}`;
          if (!sessionStorage.getItem(key)) {
            sessionStorage.setItem(key, '1');
            setOpen(true);
          }
        }
      })
      .catch(() => {});
  }, []);

  if (festivals.length === 0) return null;

  const img = (f) => IMAGES[f.deity] || IMAGES.shubh;

  return (
    <>
      <div
        onClick={() => setOpen(true)}
        style={{
          display: 'flex', alignItems: 'center', gap: 14, cursor: 'pointer', marginBottom: 16,
          padding: '10px 16px', borderRadius: 12,
          background: 'linear-gradient(135deg,#fff7e6,#fff1f0)', border: '1px solid #ffd591'
        }}
      >
        {festivals.slice(0, 3).map(f => (
          <img
            key={f.name}
            src={img(f)}
            alt={f.name}
            style={{ width: 44, height: 44, objectFit: 'cover', borderRadius: '50%', border: '2px solid #ffa940' }}
          />
        ))}
        <div>
          <div style={{ fontWeight: 700, fontSize: 16, color: '#ad4e00' }}>
            {festivals.map(f => f.greeting).join(' · ')}
          </div>
          <div style={{ fontSize: 12, color: '#8c8c8c' }}>
            {festivals.map(f => f.name).join(', ')} — {dayjs().format('DD MMM YYYY')}
          </div>
        </div>
      </div>

      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={<Button type="primary" onClick={() => setOpen(false)}>Shubhkamnaye 🙏</Button>}
        title={null}
        width={520}
        centered
      >
        <Space direction="vertical" size={18} style={{ width: '100%', textAlign: 'center' }}>
          {festivals.map(f => (
            <div key={f.name}>
              <img
                src={img(f)}
                alt={f.name}
                style={{ width: '100%', maxHeight: 340, objectFit: 'cover', borderRadius: 14 }}
              />
              <div style={{ fontSize: 26, fontWeight: 800, marginTop: 12, color: '#ad4e00' }}>{f.greeting}</div>
              <div style={{ fontSize: 15, color: '#595959' }}>{f.message || f.name}</div>
            </div>
          ))}
          <div style={{ fontSize: 13, color: '#8c8c8c' }}>— Bainsla Music / Intube Media Team</div>
        </Space>
      </Modal>
    </>
  );
}
